/**
 * Navigation module - handles AJAX page loading and link binding
 */

import { isInternalLink, removeAllURLParameters, extractInnerContent } from './utils.js';

export function bindAjaxLoad(loadContentCallback) {
  const links = document.querySelectorAll('a:not(.bound)');

  for (let a = 0; a < links.length; a++) {
    const elm = links[a];

    if (isInternalLink(elm) && !elm.classList.contains('bound')) {
      elm.classList.add('bound');
      elm.addEventListener('click', loadContentCallback);
    }
  }
}

export function setupNavigationObserver(loadContentCallback) {
  // Re-bind links periodically
  window.setInterval(function () {
    bindAjaxLoad(loadContentCallback);
  }, 400);

  // Also observe DOM changes
  const observer = new MutationObserver(() => {
    bindAjaxLoad(loadContentCallback);
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

export function loadPage(type, path, link, player, pageLoadCallback, soundBoardPlayer) {
  const cur = document.querySelector('main');
  const parent = cur.parentNode;
  const sidebars = document.querySelectorAll('.sidebar');
  const curApp = document.querySelector('.app-body');

  window.history.pushState({}, '', removeAllURLParameters(path));

  if (type === 'app' && link) {
    link.style.opacity = 0.4;
  }

  fetch(path, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(function (response) {
      return response.text();
    })
    .then(function (data) {
      const html = extractInnerContent(data);
      const sidebar = html.querySelector('.sidebar');
      const app = html.querySelector('.app-body');

      if (type === 'episode') {
        for (let a = 0; a < sidebars.length; a++) {
          const element = sidebars[a];

          if (element === player.elm && player.playing) {
            sidebar.classList.add('second-player');
            player.elm.classList.add('mini-mode');
          } else {
            if (element.parentNode) {
              element.parentNode.removeChild(element);
            }
          }
        }

        parent.append(sidebar);

        // Check if this is a live episode (has active=true in URL)
        const isLive = path.includes('active=true');
        if (isLive) {
          sidebar.dataset.autoplay = 'true';
        }

        setTimeout(function () {
          sidebar.classList.add('active');
        }, 50);
      }

      if (type === 'next-episode') {
        for (let a = 0; a < sidebars.length; a++) {
          const element = sidebars[a];

          if (element === player.elm && player.playing) {
            player.elm.classList.remove('active');
          } else {
            element.parentNode.removeChild(element);
          }
        }

        parent.append(sidebar);

        setTimeout(function () {
          sidebar.classList.add('active');
        }, 10);

        player.queElm = sidebar;
      }

      if (type === 'app' && link) {
        document.body.style.overflow = '';

        if (app) {
          app.style.opacity = 0;
          parent.append(app);
          setTimeout(function () {
            app.style.opacity = 1;
          }, 10);
        }
      }

      if (curApp) {
        const back = document.querySelector('.full-screen');

        document.body.style.overflow = '';

        if (back && back.classList.contains('inner')) {
          back.style.position = '';
          back.style.top = '';
          back.style.left = '';
          back.style.width = '';
          back.style.height = '';
          back.classList.remove('loading');
          back.classList.remove('full-screen');
          back.parentNode.style.position = '';
          back.parentNode.style.zIndex = '';

          const kids = back.children;
          for (let a = 0; a < kids.length; a++) {
            const element = kids[a];
            element.style.opacity = '';
          }
        }

        curApp.style.opacity = 0;
        document.querySelectorAll('.app').forEach(function(a) { a.style.opacity = ''; });

        setTimeout(function () {
          curApp.parentNode.removeChild(curApp);
        }, 300);
      }

      if (soundBoardPlayer) {
        soundBoardPlayer.pause();
      }

      pageLoadCallback();
    })
    .catch(function (error) {
      console.error('Error:', error);
    });
}

export function setupPopstateHandler() {
  window.addEventListener('popstate', function () {
    location.reload(true);
  });
}
